import { render } from "./LabelsSvgIcon.vue?vue&type=template&id=ab11e65c"
import script from "./LabelsSvgIcon.vue?vue&type=script&lang=js"
export * from "./LabelsSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__